module.exports = __webpack_public_path__ + "img/pen.5cb12bea.png";